import { getPaymentSystem } from './getCart';
import getUberToken from './getUberToken';
import getLocale from './getLocale';

export default function getConfig(state) {
    const { config = {} } = state;
    return config;
}

function getHeadConfig(state) {
    const config = getConfig(state);

    // legacy config support
    if (config.watsonService) {
        return config;
    }

    const { head = {} } = config;
    return head;
}

export function getShoppingBagPromptConfig(state) {
    const { config = {} } = state;
    const { enableShoppingBagPrompt = false } = config?.head || {};
    return enableShoppingBagPrompt;
}

export function getWatsonConfig(state) {
    const uberToken = getUberToken(state);
    const { country, language } = getLocale(state);
    const config = getConfig(state);

    // legacy config support
    if (config.watsonService) {
        return { uberToken, country, language, ...config.watsonService };
    }

    const { global = {} } = getConfig(state);
    const { commerce = {} } = global.services;
    const { brandId } = global.application;
    return { uberToken, country, language, brandId, ...commerce };
}

export function getPaymentConfig(state) {
    const config = getConfig(state);
    const vaultService = config.vaultService || config.global.services.vault;
    const paymentService = config.paymentService || config.global.services.payment;
    const requestBrand = config.brandId || config.global.application.brandId;

    const paymentSystem = getPaymentSystem(state);

    if (paymentSystem === 'YPayment') {
        return { paymentSystem, requestBrand, ...vaultService };
    }

    return { paymentSystem, requestBrand, ...paymentService };
}

export function getTimeout(state) {
    const { clientRequest = {} } = getHeadConfig(state);

    return clientRequest.timeout;
}

export function getDelay(state) {
    const { clientRequest = {} } = getHeadConfig(state);

    return clientRequest.delay;
}

export function getAnalyticsConfig(state) {
    const { business } = getConfig(state);
    return {
        business,
        deviceType: state.deviceType,
    };
}
